<div class="modal-xlg">
  <div class="fund-details">
    <div class="otpsub">
      <div class="head">
        <div style="text-align: center">
          <img
            itemprop="image"
            class="logo logo-dark mt-x1"
            alt="CoinZoom Exchange"
            src="./assets/image/icons/logo_white.svg"
            width="200"
          />
        </div>
        <span>
          <button type="button" class="close pull-right" aria-label="Close" (click)="hideModal()">X</button>
        </span>
      </div>
      <div class="fund-summary">
        <span class="fund-summary-text">These recent deposits can be withdrawn on the dates shown :-</span>
      </div>
      <div class="table-wrapper">
        <table class="market table-hover" width="100%">
          <thead>
            <tr>
              <th class="text-center type-col">Type</th>
              <th class="text-center amount-col">Deposit Amount</th>
              <th class="text-center amount-col">Held Amount</th>
              <th class="text-center date-col">Transaction Date</th>
              <th class="text-center withdraw-col">Can be withdrawn on</th>
            </tr>
          </thead>
        </table>
        <div class="subtab position-relative">
          <div class="market_table table-striped table-hover fund-history-rows" width="100%">
            @for (fund of fundDetails; track fund) {
              <div class="fund-history-row">
                <div class="fund-history-cell text-center type-col">
                  <span>{{ getDisplayHoldType(fund) }} </span>
                </div>
                <div class="fund-history-cell text-center amount-col">
                  <span>{{ fund?.feeAdjustedTransferAmt }}</span>
                </div>
                <div class="fund-history-cell text-center amount-col">
                  <span>{{ fund?.holdAmt }}</span>
                </div>
                <div class="fund-history-cell text-center date-col">
                  <span>{{ fund?.eventTs | localdate }}</span>
                </div>
                <div class="fund-history-cell text-center withdraw-col">
                  <span>{{ fund?.holdUntilTs | localdate }}</span>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
